export const API_DEFAULT_CONFIG = {
  dataType: 'json',
  withCredentials: true,
  timeout: 120000,
  validateStatus: (status: number) => status >= 200 && status < 300,
  headers: {
    ['Content-Type']: 'application/json; charset=utf-8',
  },
}
